    import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardBody,
    Image,
    Text,
    Flex,
    SimpleGrid,
    Spinner,
    Center,
    Select,
    Button,
    InputGroup,
    InputLeftElement,
    Input,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    IconButton,
    MenuDivider,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    useToast,
    Badge,
    Switch,
    Stack,
    useColorModeValue,
    Link,
    Icon,
    Tooltip,
} from '@chakra-ui/react';
import axiosClient from '../../axios-client';
import MyPagination from '../../components/MyPagination';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PiPlusBold } from 'react-icons/pi';
import { SearchIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import { BsThreeDotsVertical } from "react-icons/bs";
import { useStateContext } from '../../context/ContextProvider';
import MySelect from 'react-select';
import { FaGamepad, FaHistory } from 'react-icons/fa';

const GestGames = () => {
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [paginationData, setPaginationData] = useState();
    const [selectedEtat, setSelectedEtat] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [loadingData, setLoadingData] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [checkLengthData, setCheckLengthData] = useState(false);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(0);
    const [deleteId, setDeleteId] = useState(null);
    const toast = useToast();
    const { user } = useStateContext();
    const colorbg = useColorModeValue('white', '#2d3748');
    const txtcolor = useColorModeValue('black', 'white');
    const colorbghover = useColorModeValue('#e2e8f0', '#171923');
    const { t } = useTranslation();
    const cancelRef = React.useRef();

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryOptions, setCategoryOptions] = useState([]);

    //////////////////////////////// Page size //////////////////////////////
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const onOpenAlert = (id) => {
        setIsAlertOpen(true);
        setDeleteId(id);
    };

    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };

    // Fetch Categories
    useEffect(() => {
        axiosClient.get('categories/')
            .then(response => {
                const formattedOptions = response.data.results.map(category => ({
                    value: category.id,
                    label: category.name
                }));
                setCategoryOptions(formattedOptions);
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
            });
    }, []);

    // Fetch Games
    useEffect(() => {
        setLoadingData(true);

        const params = {
            page_size: pageSize,
            page: currentPage + 1,
            search_term: searchTerm,
        };

        // if (selectedEtat !== null) params.etat = selectedEtat;
        if (selectedStatus) params.status = selectedStatus;
        if (selectedCategory) params.category = selectedCategory.value;

        axiosClient.get('/games/', { params })
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true);
                }

                setGames(filteredData);
                setLoadingData(false);
            })
            .catch((error) => {
                console.error(error);
                setLoadingData(false);
            });
    }, [selectedEtat, selectedStatus, pageSize, currentPage, searchTerm, selectedCategory]);

    if (error) {
        return (
            <Center mt={10}>
                <Text color="red.500">{error}</Text>
            </Center>
        );
    }

    const handleDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/games/delete/${id}/`)
            .then((response) => {
                setGames((prevData) => prevData.filter((row) => row.id !== id));

                toast({
                    description: t("Le jeu est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
            })
            .catch((error) => {
                toast({
                    description: t("Erreur lors de la suppression"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
            });
        onCloseAlert();
    };

    const handleEtatClick = (id, etat) => {
        const formData = new FormData();
        formData.append("etat", !etat);
        formData.append('edited_by', `${user.last_name} ${user.first_name}`);

        axiosClient.put(`/games/update/${id}/`, formData)
            .then((response) => {
                const updatedRow = response.data;
                setGames(rows => rows.map(row => {
                    if (row.id === id) {
                        return {
                            ...row,
                            etat: !etat,
                        };
                    }
                    return row;
                }));

                toast({
                    description: !etat ? t("Le jeu est activé") : t("Le jeu est désactivé"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
            })
            .catch((error) => {
                console.error(error);
                toast({
                    description: t("Erreur lors de la mise à jour"),
                    status: 'error',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
            });
    };

    return (
        <Box p={5}>
            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray">
                        <span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"}>
                            {t("Accueil")}
                        </span> / <span>{t("Liste des jeux")}</span>
                    </Text>
                    <Button 
                        onClick={() => navigate('/ajouter-jeu')} 
                        leftIcon={<PiPlusBold />} 
                        color={"white"} 
                        bgGradient='linear(to-r, #eb6921, #fa8d51)' 
                        _hover={{ bgGradient: 'linear(to-r, #eb6921,#eb6921)' }} 
                        variant='solid'
                    >
                        {t("Ajouter un jeu")}
                    </Button>
                </Box>
            </Flex>

            {/* Filters */}
            <Flex flexDirection={{ base: "column", lg: "row" }} gap={5} py={5} justify={"space-between"}>
                <Flex direction={{ base: 'column', md: "row" }} gap={2} w={{ base: '100%', lg: "60%" }}>
                    <Flex w={{ base: '100%', md: '50%', lg: "35%" }}>
                        <MySelect
                            options={categoryOptions}
                            onChange={setSelectedCategory}
                            placeholder={t("Catégorie")}
                            isClearable
                            styles={{
                                container: (base) => ({
                                    ...base,
                                    zIndex: 99,
                                    width: '100%',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: '1px solid #CBD5E0',
                                    backgroundColor: 'transparent',
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    textAlign: 'left',
                                    backgroundColor: colorbg,
                                    cursor: "pointer"
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    color: txtcolor,
                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                    '&:hover': {
                                        backgroundColor: colorbghover,
                                    },
                                    cursor: "pointer"
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: txtcolor
                                }),
                            }}
                        />
                    </Flex>

                    <Select
                        style={{ border: '1px solid #CBD5E0' }}
                        borderRadius="5"
                        fontSize={{ base: 13, lg: 16 }}
                        w={{ base: '100%', md: '50%', lg: "35%" }}
                        value={selectedStatus || ''}
                        onChange={(e) => setSelectedStatus(e.target.value === '' ? null : e.target.value)}
                    >
                        <option value="">{t("Tous les statuts")}</option>
                        <option value="draft">{t("Brouillon")}</option>
                        <option value="published">{t("Publié")}</option>
                    </Select>

                    {/* <Select
                        style={{ border: '1px solid #CBD5E0' }}
                        borderRadius="5"
                        fontSize={{ base: 13, lg: 16 }}
                        w={{ base: '100%', md: '50%', lg: "30%" }}
                        mb={4}
                        value={selectedEtat === null ? '' : selectedEtat.toString()}
                        onChange={(e) => setSelectedEtat(e.target.value === '' ? null : e.target.value === 'true')}
                    >
                        <option value="">{t("Tout")}</option>
                        <option value="true">{t("Activé")}</option>
                        <option value="false">{t("Désactivé")}</option>
                    </Select> */}
                </Flex>

                <InputGroup mb={3} size="md" w={{ base: '100%', lg: "40%" }}>
                    <InputLeftElement
                        pointerEvents='none'
                        children={<SearchIcon color='gray.300' />}
                    />
                    <Input
                        style={{ border: '1px solid #CBD5E0' }}
                        borderRadius="5"
                        placeholder={t("Recherche...")}
                        value={searchTerm}
                        onChange={(e) => {
                            setCurrentPage(0);
                            setSearchTerm(e.target.value);
                        }}
                        sx={{
                            marginLeft: 'auto',
                        }}
                    />
                </InputGroup>
            </Flex>

            {/* Games Grid */}
            <SimpleGrid columns={!loadingData ? { base: 1, md: 2, lg: 3 } : { base: 1 }} spacing={5}>
                {!loadingData
                    ? games.length > 0
                        ? games.map((game) => (
                            <Card
                                key={game.id}
                                borderRadius="md"
                                boxShadow="md"
                                overflow="hidden"
                                transition="all 0.3s"
                                _hover={{ transform: 'translateY(-4px)', boxShadow: 'lg' }}
                            >
                                <Box position="relative">
                                    <Menu>
                                        <MenuButton
                                            position="absolute"
                                            top="5px"
                                            right="5px"
                                            zIndex="9"
                                            as={IconButton}
                                            icon={<BsThreeDotsVertical />}
                                            variant="ghost"
                                            color="orange"
                                            bg="whiteAlpha.800"
                                            _hover={{ bg: 'whiteAlpha.900' }}
                                        />
                                        <MenuList zIndex="9999">
                                            <MenuItem
                                                _hover={{ background: "none" }}
                                                onClick={() => navigate(`/detail-jeu`, { state: { gameId: game?.id } })}
                                            >
                                                {t("Détails du jeu")}
                                            </MenuItem>
                                            <MenuItem
                                                _hover={{ background: "none" }}
                                                onClick={() => navigate(`/modifier-jeu`, { state: { gameId: game?.id } })}
                                            >
                                                {t("Modifier le jeu")}
                                            </MenuItem>
                                            {/* <MenuItem
                                                _hover={{ background: "none" }}
                                                onClick={() => navigate(`/historique-jeu`, { state: { gameId: game?.id } })}
                                                icon={<FaHistory />}
                                            >
                                                {t("Historique du jeu")}
                                            </MenuItem> */}
                                            {/* <MenuItem _hover={{ background: "none" }}>
                                                <Flex w={"100%"} justifyContent="space-between">
                                                    <Badge
                                                        size="sm"
                                                        rounded={'lg'}
                                                        colorScheme={!game.etat ? 'red' : 'green'}
                                                    >
                                                        {game.etat ? t("Activé") : t("Désactivé")}
                                                    </Badge>
                                                    <Stack direction='row' mr="3px">
                                                        {(user.role === "SUPERADMIN" || user.role === "ADMIN") &&
                                                            <Switch
                                                                colorScheme='green'
                                                                isChecked={game.etat}
                                                                onChange={() => handleEtatClick(game.id, game.etat)}
                                                            />
                                                        }
                                                    </Stack>
                                                </Flex>
                                            </MenuItem> */}

                                            {(user.role === "SUPERADMIN") && (
                                                <>
                                                    <MenuDivider />
                                                    <MenuItem
                                                        onClick={() => onOpenAlert(game.id)}
                                                        _hover={{ background: "none" }}
                                                        color="red.500"
                                                    >
                                                        {t("Supprimer le jeu")}
                                                    </MenuItem>
                                                </>
                                            )}
                                        </MenuList>
                                    </Menu>

                                    {game.image ? (
                                        <Image
                                            borderRadius="md"
                                            height="200px"
                                            width="100%"
                                            objectFit="cover"
                                            src={game.image}
                                            alt={game.title}
                                        />
                                    ) : (
                                        <Flex
                                            height="200px"
                                            width="100%"
                                            bg="gray.200"
                                            align="center"
                                            justify="center"
                                            borderRadius="md"
                                        >
                                            <Icon as={FaGamepad} boxSize={16} color="gray.400" />
                                        </Flex>
                                    )}

                                    <CardBody>
                                        <Flex direction="column" gap={2}>
                                            <Flex justify="space-between" align="center">
                                                <Text fontSize="lg" fontWeight="bold" noOfLines={1}>
                                                    {game.title}
                                                </Text>
                                                <Badge
                                                    colorScheme={game.status === 'published' ? 'green' : 'gray'}
                                                    fontSize="0.7em"
                                                >
                                                    {game.status === 'published' ? t('Publié') : t('Brouillon')}
                                                </Badge>
                                            </Flex>

                                            <Text color="gray.500" fontSize="sm" noOfLines={2}>
                                                {game.description}
                                            </Text>

                                            {game.categories && game.categories.length > 0 && (
                                                <Flex gap={1} flexWrap="wrap">
                                                    {game.categories.slice(0, 3).map((category, idx) => (
                                                        <Badge key={idx} colorScheme="orange" fontSize="0.65em">
                                                            {category.name}
                                                        </Badge>
                                                    ))}
                                                    {game.categories.length > 3 && (
                                                        <Badge colorScheme="orange" fontSize="0.65em">
                                                            +{game.categories.length - 3}
                                                        </Badge>
                                                    )}
                                                </Flex>
                                            )}

                                            <Tooltip label={t("Ouvrir le jeu")} placement="top">
                                                <Link
                                                    href={game.game_url}
                                                    isExternal
                                                    color="cyan.500"
                                                    fontSize="sm"
                                                    fontWeight="medium"
                                                    display="flex"
                                                    alignItems="center"
                                                    gap={1}
                                                    _hover={{ textDecoration: 'underline' }}
                                                >
                                                    <ExternalLinkIcon />
                                                    {t("Jouer")}
                                                </Link>
                                            </Tooltip>
                                        </Flex>
                                    </CardBody>
                                </Box>
                            </Card>
                        ))
                        : <Text>{t("Aucun jeu correspondant n'a été trouvé.")}</Text>
                    : <Flex justify='center'>
                        <Spinner size="xl" />
                    </Flex>
                }
            </SimpleGrid>

            {/* Pagination */}
            <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%" mt={5}>
                <Box flex="1">
                    <MyPagination
                        paginationData={paginationData}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        PAGE_SIZE={pageSize}
                    />
                </Box>

                <Select w="70px" value={pageSize} onChange={handlePageSizeChange}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                </Select>
            </Flex>

            {/* Delete Alert Dialog */}
            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer le jeu")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("Êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(deleteId)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>
    );
};

export default GestGames;